"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagPN = function FlagPN(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.3v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.48v5.6a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.48L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122H-101.2v56.5H-193v21.18h91.8v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.23a6.94,6.94,0,0,0-3.37,5.86v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M116.77-50.73a.82.82,0,0,1-.47-.15c-.1-.09-11.07-8.63-4.61-23.11a.76.76,0,0,1,1-.38.76.76,0,0,1,.39,1c-6,13.34,3.73,21,4.15,21.26a.77.77,0,0,1,.14,1.07.74.74,0,0,1-.6.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.45-63.23h-.09a.76.76,0,0,1-.67-.84c.32-2.74,1.35-4.65,3.07-5.68,2.76-1.66,6.2-.33,6.35-.28a.77.77,0,0,1,.43,1,.76.76,0,0,1-1,.43s-2.91-1.1-5,.17c-1.29.77-2.07,2.3-2.33,4.54a.77.77,0,0,1-.76.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M112.52-73c-.06-.17-1.71-4.08-9.16-2.42-8.43,1.89-8.52,13-8.52,13.13a.76.76,0,0,0,.66.75h.1a.75.75,0,0,0,.73-.57c3.15-12,14.85-10,15.35-9.87a.75.75,0,0,0,.72-.27.75.75,0,0,0,.12-.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.77-66.85s-5.08-3.24-7.18.89-.5,8.57.32,10.34c0,0,3-3.34,5.91-3.81,3.55-.57,4.44-5,2-7.23-3-2.66-1-.19-1-.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M116.32-74.44c-.08,4.45,2.4,5,2.4,5a3.5,3.5,0,0,0-2.4-5Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M115.54-65.1c0-4.22,2.89-4.69,2.89-4.69,1.73,3.92-2.89,4.69-2.89,4.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M132-68.5a29.89,29.89,0,0,1-5.59-1.33c-1.29-.61-3-2.08-5.16-1.79a3,3,0,0,0-3,3c0,1.67,1.14,3.66,7.13,3.22a11.05,11.05,0,0,1,5.38,1.11c-.39-1.58,1.25-4.22,1.25-4.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M127.84-67.18s-6.2.43-7.57-.57-.93-2.41.36-2.55c1.94-.21,7.21,3.12,7.21,3.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M139.9-60.16l-13.71,8.57-1.57-1.52,7.52-7.28,1.76.71L135.62-62l-4.1-2.15S120.67-53.87,111.43-53a19,19,0,0,1-8.74-.93l-5.54,8,11.62,9.9,17-.66L139.9-55.87l2.47,1.14,2.1-2.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#b49b91"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M101.69-37.08A6.94,6.94,0,0,1,94.77-44a6.94,6.94,0,0,1,6.92-6.92A6.94,6.94,0,0,1,108.61-44a6.93,6.93,0,0,1-6.92,6.92Zm0-11.55A4.64,4.64,0,0,0,97.06-44a4.64,4.64,0,0,0,4.63,4.63A4.63,4.63,0,0,0,106.32-44a4.63,4.63,0,0,0-4.63-4.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#9b8278"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M130.51-30.67s1.27-.83,2.54-4.7l-2.6.39a7.92,7.92,0,0,0-.07-3.75l-2.92,2.28a15.32,15.32,0,0,0-1.9-3.17s-2,2.86-3.17,3.24c0,0-1.15-4.13-2.29-4.95l-2,2.79-2.92-2.29s0,2-.06,2.42-3.81-3.94-3.81-3.94-1.65.7-3.87,4.25l-2.79-2.85-1.15,3.74-3.87-1,.63,2.22-3.36-.26s.57,3.3,2.22,4.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96.87-16.55S86.39-3.21,66.59-4.74l21.52,3,11-10.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M62.68-6.74C64.78-5.21,77.73-1.5,87.06-6a5.42,5.42,0,0,1-.86,3.43s6.85-2.76,10.57-7.9-7.71,11-7.71,11L71.54,3.83l-7.15-5.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.3-54.74a9.21,9.21,0,0,0-6.12,3.29,4.13,4.13,0,0,0-3.55.43c-1.72,1.15-4.9,5.29-7.56,4.2A3.49,3.49,0,0,0,48-43.06a7.2,7.2,0,0,0-.86,4.19,5.69,5.69,0,0,1-1.67,4.28s8.39,1.19,8.72-5.33c0-.8.08-1.5.12-2.13,4.37,2.36,6.09-1,6.09-1s-2.62-2.48.05-6,10,4.8,10,4.8c.14-3.33-.16-11.26-9.15-10.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M93.69-32.77s-2.41,1.66-9.9.13c0,0,1.65-3.68.89-5.84a23,23,0,0,1-7,3.81c-5,1.9-11,8-12.83,11.94,0,0,11.14-25.68,2.19-28.29a6.09,6.09,0,0,0-6.64,2,3.86,3.86,0,0,1,.93,2.31c.1,2.19-2.1,16.95-5.33,27.14,0,0-1-3.53-2.48-5.24a19,19,0,0,1-2.66-4.47,5.31,5.31,0,0,0-2.19,4.85s-1.43-1.14-4.19-.38-3.81-1.05-3.81-1.05-2.29,6.09,4.47,9.24a18.25,18.25,0,0,0-2.66,1.52,4.08,4.08,0,0,1-2.19.67A10.07,10.07,0,0,0,47.73-9.6c5.05.48,7.37,1.92,9,4.51,5.15,8.41,15,14.79,31.05,5,0,0-22.85,7.11-23.87-7.49C63-20.4,76.93-23,78.33-20.2A5.57,5.57,0,0,1,78.2-15s7.62-1.78,3.94-8.76c0,0,7.49,1.14,11.55-9Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M167-6.74C165-5.21,151.71.5,142.57-8.64S129.86-31.51,130.38-30h-9.14l3.05,27.42,33.9,6.38,7.14-5.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M168.42-54.74a9.23,9.23,0,0,1,6.13,3.29,4.14,4.14,0,0,1,3.55.43c1.72,1.15,4.89,5.29,7.56,4.2a3.5,3.5,0,0,1-3.91,3.76,7.2,7.2,0,0,1,.86,4.19,5.69,5.69,0,0,0,1.67,4.28s-8.38,1.19-8.72-5.33c0-.8-.08-1.5-.11-2.13-4.38,2.36-6.1-1-6.1-1s2.63-2.48,0-6-10,4.8-10,4.8c-.15-3.33.15-11.26,9.14-10.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M136-32.77s2.41,1.66,9.9.13c0,0-1.64-3.68-.88-5.84,0,0,2,1.91,7,3.81s11,8,12.82,11.94c0,0-11.14-25.68-2.19-28.29a6.09,6.09,0,0,1,6.64,2,3.79,3.79,0,0,0-.92,2.31c-.1,2.19,2.09,16.95,5.33,27.14,0,0,.95-3.53,2.47-5.24a19.21,19.21,0,0,0,2.67-4.47A5.33,5.33,0,0,1,181-24.45s1.42-1.14,4.19-.38S189-25.88,189-25.88s2.28,6.09-4.48,9.24a18.71,18.71,0,0,1,2.67,1.52,4,4,0,0,0,2.18.67A10,10,0,0,1,182-9.6c-5.05.48-7.37,1.92-9,4.51-5.14,8.41-15,14.79-31,5,0,0,22.85,7.11,23.87-7.49C166.75-20.4,152.79-23,151.39-20.2a5.6,5.6,0,0,0,.13,5.21s-7.62-1.78-3.93-8.76c0,0-7.5,1.14-11.56-9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M129.56-11.43C133.3-6,138.51-1,153.61,3.67s19.15,5.4,27.07,11.8a9.66,9.66,0,0,1,2.08,4.14c.67,3-3.94,11.61-3.94,11.61s.45-2-2.35-6-19.29-11-27.93-13.2S125-.12,129.12-7.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M180.66,15.45l0,0,0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M180.28,34a6.66,6.66,0,0,1-1.9,5.14c-2.29,2.38-3.9,4.09-3.81,6.09,0,0-3.43-2.47-2.86-8,0,0-4.47,3.72-11.23.1,0,0,.66-6.76,9.43-7.62,0,0-3.43-2.66,1-6.76,0,0,.52,1.83,4.57,2.76,3.53.81,9.79-3.6,5.16-10.26,8,9,3.89,15.21-.4,18.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126.29-16.45a21.6,21.6,0,0,0,7,6.22c6,3.68,6.57,5.39,6.57,5.39l-4.1-.09s5.24,2.86,6.67,6.48a12,12,0,0,1-4.67-.29s2,1.81,1,7.62H128.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M106,9.64V-14.73S97.73-.58,90.59,9.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M98.89-15.25C96.86-11.56,90.51.56,75.4,5.26S57.53,9.07,49.61,15.47a9.66,9.66,0,0,0-2.08,4.14c-.67,3,3.94,11.61,3.94,11.61s-.44-2,2.35-6S73,13.8,81.75,12.05c12.07-2.41,23-15.36,21.21-23.74s-4.07-3.56-4.07-3.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.63,15.45l0,0,0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,34a6.66,6.66,0,0,0,1.9,5.14c2.29,2.38,3.91,4.09,3.81,6.09,0,0,3.43-2.47,2.86-8,0,0,4.47,3.72,11.24.1,0,0-.67-6.76-9.43-7.62,0,0,3.43-2.66-1-6.76,0,0-.52,1.83-4.57,2.76-3.52.81-9.79-3.6-5.15-10.26-8,9-3.89,15.21.39,18.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M71.09,74.64a110.45,110.45,0,0,1,2.29,19.74s9.46.32,14-6.79c0,0-9.14-4.76-14-14Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.06,53.19C68.68,48.61,70.71,37.06,80,28.68l.23-10.26A10.36,10.36,0,0,0,75,20.85L69.76,29,64.91,47.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.32,56.49s0,9.77,4.06,17.13l-2.29,1S62.9,68.2,61.19,55c0,0-7.33,4.86-10-5.08,0,0,7.87,3.18,10.41-4.06,2.29-6.53,4.61-18.41,13.43-25-4.2,6.45-10.51,22.94-5.62,28.78,1.29,1.55,5,2.86,9.08,1.12C78.2,54,76.65,59,69.32,56.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M70.5,76.38l-1.34-2.46a.9.9,0,0,1,.36-1.21L72,71.39a.88.88,0,0,1,1.2.35L74.5,74.2a.89.89,0,0,1-.36,1.2L71.7,76.73a.89.89,0,0,1-1.2-.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffce5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M153.11,74.64a110.45,110.45,0,0,0-2.29,19.74s-9.46.32-14-6.79c0,0,9.14-4.76,14-14Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M155.14,53.19c.38-4.58-1.65-16.13-10.92-24.51L144,18.42a10.38,10.38,0,0,1,5.2,2.43L154.44,29l4.86,18.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M145.73,50.75c4.08,1.74,7.8.43,9.09-1.12,4.89-5.84-1.42-22.33-5.62-28.78,8.82,6.56,11.14,18.44,13.43,25,2.54,7.24,10.41,4.07,10.41,4.07-2.7,9.93-10,5.07-10,5.07-1.71,13.24-9.9,19.68-9.9,19.68l-2.29-1c4.07-7.36,4.07-17.13,4.07-17.13C147.55,59,146,54,145.73,50.75Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M153.7,76.38,155,73.92a.89.89,0,0,0-.35-1.21l-2.44-1.32a.88.88,0,0,0-1.2.35L149.7,74.2a.88.88,0,0,0,.36,1.2l2.44,1.33a.9.9,0,0,0,1.2-.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffce5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.63,6.59a3,3,0,0,0-3,3.05V43.16c0,9.14,3,42.65,33.51,54.84,30.47-12.19,33.52-45.7,33.52-54.84V9.64a3.06,3.06,0,0,0-3.05-3.05Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.25,6.59,81.36,62a67,67,0,0,0,2.75,7.89l28-53.64,28,53.64A67,67,0,0,0,142.84,62L114,6.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M140.09,69.87l-28-53.64-28,53.64c4.61,10.91,13,22.12,28,28.13,15-6,23.38-17.22,28-28.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M123.43,73.34l1.84.88a15.17,15.17,0,0,1-5.45,4.67,63.65,63.65,0,0,0-6.2,3.91V57.65l7.62-.78v-3L113.62,53V49.25a1.51,1.51,0,0,0-3-.35,3,3,0,0,0-1.75-.62,3.1,3.1,0,0,0-3.1,3.09,3.06,3.06,0,0,0,.83,2.07l-3.66.38v3l7.62.78V82.8a62.46,62.46,0,0,0-6.2-3.91,15.08,15.08,0,0,1-5.45-4.67l1.84-.88-7-8.86V76.67l2.34-1.12a17.72,17.72,0,0,0,6.77,6,66.16,66.16,0,0,1,7.64,5l1.53,1.18,1.52-1.18a67.41,67.41,0,0,1,7.65-5,17.72,17.72,0,0,0,6.77-6l2.34,1.12V64.48Zm-14.54-20.4a1.57,1.57,0,1,1,1.56-1.56,1.56,1.56,0,0,1-1.56,1.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.45,46.2h-4.7A2.21,2.21,0,0,1,107.53,44V36.23A2.21,2.21,0,0,1,109.75,34h4.7a2.21,2.21,0,0,1,2.22,2.21V44a2.21,2.21,0,0,1-2.22,2.21Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M133.43,6.59c-6.09-9.14-6.09-27.42-6.09-27.42S127.34-33,112.1-33c-7.72,0-11.52,3.13-13.4,6.22a24.44,24.44,0,0,0-11,9,22.41,22.41,0,0,0,8.37,2.5A29.33,29.33,0,0,1,103.16.43c-2.87,2.93-4.45,10-.2,15.3a40.92,40.92,0,0,0,16.63-9.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#b49b91"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M119.58,6.59H131c-.57-5.62-6.09-4.71-11.37,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#9b8278"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M130.67.84c-3.33-9.45-3.33-21.67-3.33-21.67a5.13,5.13,0,0,0,0-.54c-4-.54-8-.25-16,2.83-8.45,3.27-12.59,3.36-15.25,3.25A29.18,29.18,0,0,1,103.15.43l.13,6.48s4.76.7,15.23-5.33c5.22-3,9.65-3.27,12.16-.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#9b8278"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.45-22.16c6.18-1.55,10.12-1.39,12.66-.49C126.43-26,123.63-33,112.1-33c-7.72,0-11.52,3.13-13.4,6.22l-4.63,6.48s5.79,1.8,20.38-1.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#9b8278"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M102-34.35c.6.6,2.39,4.91,2,5.56-.23.41-5,1.59-5.78,1s-1.49-5.19-1-5.73,4.29-1.32,4.79-.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M108.16-34.58c.55.63,1.81,4.85,1.31,5.39-.31.35-5.63.77-6.37.1s-.8-5-.22-5.41,4.82-.61,5.28-.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114-34.74c.58.6,1.89,4.56,1.37,5.07-.33.32-5.82.71-6.59.08s-.84-4.68-.24-5.09,5-.56,5.46-.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M119.86-34.46c.51.65,1.47,4.81.93,5.29-.34.31-5.67.33-6.36-.37s-.45-4.86.16-5.23,4.85-.24,5.27.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M132-31.94c.4.73.36,4.59-.25,5-.39.25-5.19-.61-5.75-1.41s.35-4.87,1-5.13,4.66,1,5,1.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126.44-33.59c.48.66.84,4.54.27,5-.38.27-5.87-.18-6.53-.9s-.16-4.64.49-4.94,5.37.34,5.77.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M103.76-44a2.07,2.07,0,0,1-2.07,2.07A2.06,2.06,0,0,1,99.62-44a2.07,2.07,0,0,1,2.07-2.07A2.07,2.07,0,0,1,103.76-44Zm0,0",
    transform: "translate(194 123)",
    fill: "#9b8278"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagPN;
exports["default"] = _default;